import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _authService: AuthenticationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (localStorage.getItem('DashboardToken') !== null) {
      const currentUser = JSON.parse(localStorage.getItem('DashboardToken'));
      this._authService.CheckToken();
      return true;
    }
    this._authService.logout(state);
    return false;
  }
}
